<template>
  <div class="chat-widget elevated-card d-flex" style="flex-direction: column; width: 18.1875rem">
    <div v-for="(element, element_i) in multiple_selection" :key="element_i" class="selection-card">
      <div class="selection-title">{{ element.title }}</div>
      <div class="selection-subtitle">{{ element.subtitle }}</div>
      <v-row no-gutters>
        <v-col cols="auto" v-for="(option, option_i) in element.options" :key="option_i">
          <div @click="toggleSelection(option, element.max_selection)" class="selection-chip" :style="selected_list.includes(option) ? 'background: rgba(0, 0, 0, 0.24)' : ''">
            {{ option.title }}
          </div>
        </v-col>
      </v-row>
      <div class="d-flex" style="justify-content: end; padding-top: 0.5rem">
        <button @click="submit" v-ripple class="selection-submit-button text-none white--text" :style="`background: ${config.main_color}`">
          <v-icon :color="config.text_color" class="plus-btn">mdi-check</v-icon>
          <span class="submit-btn-text" style="padding-left: 0.375rem !important"> {{ $vuetify.locale.t('$vuetify.__General.submit') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
// Import modules
import global_config from '@/../config.json'
import { ref, defineProps } from 'vue'
import { useStore } from 'vuex'

// Init Modules
const store = useStore()

// Props
const { multiple_selection } = defineProps({ multiple_selection: Array })

// Data
const config = ref(global_config)
const selected_list = ref([])

// Methods
const toggleSelection = (option, max_selection) => {
  let index = selected_list.value.findIndex((item) => item.payload === option.payload)
  if (index >= 0) selected_list.value.splice(index, 1)
  else {
    if (max_selection) {
      if (selected_list.value.length < max_selection) selected_list.value.push(option)
    } else selected_list.value.push(option)
  }
}
const submit = () => {
  let title = ''
  let value = ''
  selected_list.value.forEach((item, i) => {
    if (i > 0) {
      title = title.concat(',')
      value = value.concat(',')
    }
    title = title.concat(item.title)
    value = value.concat(item.payload)
  })
  store.dispatch('sendMessageToSocket', { title, value })
}
</script>

<style scope>
.selection-card {
  padding: 1rem 1.5rem;
}

.selection-title {
  color: #1a1a1a;
  font-size: 18px;
  font-weight: 700;
  line-height: normal;
  padding-bottom: 1rem;
}

.selection-subtitle {
  color: #828282;
  font-size: 15px;
  font-weight: 400;
  line-height: normal;
  padding-bottom: 1rem;
}

.selection-chip {
  border-radius: 0.75rem;
  border: 0.0625rem solid rgba(0, 0, 0, 0.2);
  padding: 0.375rem 1rem !important;
  margin: 0 0.5rem 0.5rem 0;
}

.selection-submit-button {
  border-radius: 0.75rem;
  padding: 0.625rem 1rem;
}

.submit-btn-text {
  color: #fff;
}
</style>
